export default "__VITE_ASSET__Cnk1ze_u__"